import { ProductStock } from './stock.types';

type ProductLike = {
  name: string;
  presentations?: { items?: { id: string; name: string }[] };
  options?: { items?: { id: string; name: string }[] }[];
};

const findChildName = (
  product: ProductLike,
  stock: Pick<ProductStock, 'id' | 'entityType'>,
): string | undefined => {
  if (stock.entityType === 'presentation') {
    return product.presentations?.items?.find(item => item.id === stock.id)?.name;
  }
  if (stock.entityType === 'option-item') {
    return (product.options ?? [])
      .flatMap(option => option.items ?? [])
      .find(item => item.id === stock.id)?.name;
  }
  return undefined;
};

export const productStockNodeName = (
  product: ProductLike,
  stock: Pick<ProductStock, 'id' | 'entityType'>,
): string => {
  const childName = findChildName(product, stock);

  return childName ? `${product.name} · ${childName}` : product.name;
};
